import { useEffect, useState } from "react";
import { TOKEN_KEY } from "@/lib/api";
import { logSecurityEvent } from "@/components/SecurityLog";

// Multi-finger (3+) touch privacy overlay (#blank-screen-overlay). Single tap restores. Never touches media tracks.
export const TouchGuard = () => {
  const [blank, setBlank] = useState(false);
  useEffect(() => {
    const trigger = (kind) => { setBlank(true); if (localStorage.getItem(TOKEN_KEY)) logSecurityEvent(kind, document.querySelector('[data-testid="call-screen"]') ? "കോളിനിടെ" : null); };
    const touch = (e) => { if (e.touches && e.touches.length >= 3) trigger("multi_touch"); };
    document.addEventListener("touchstart", touch, { passive: true, capture: true });
    return () => { document.removeEventListener("touchstart", touch, true); };
  }, []);
  if (!blank) return null;
  return (
    <div id="blank-screen-overlay" data-testid="blank-screen-overlay" onClick={() => setBlank(false)} className="fixed inset-0 z-[120] bg-black flex flex-col items-center justify-center gap-2 text-white/70 select-none">
      <span className="text-3xl">🔒</span>
      <p className="text-sm font-semibold">സ്വകാര്യതാ സംരക്ഷണം — സ്ക്രീൻ ഓഫ്</p>
      <p className="text-[11px] text-white/40">തുടരാൻ ഒരു തവണ ടാപ്പ് ചെയ്യുക</p>
    </div>
  );
};
